import React from "react"

import Layout from "./../components/layout"
import Seo from "./../components/SEO"
import Project from "./../components/project"

import Bac from "./../../static/Project-Images/BACWizard.png"
import Dd from "./../../static/Project-Images/DailyDiscomfort.png"
import CodeADiffImage from "./../../static/Project-Images/CodeADifference.png"
import FunnyWeatherImage from "./../../static/Project-Images/FunnyWeather.png"
import CodeThemeFinderImage from "./../../static/Project-Images/CodeThemeFinder.jpg"

import Container from "react-bootstrap/Container"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"

//BAC
const BACDescription =
  "BAC Wizard is an application to track your estimated BAC while drinking. Every time you have a drink (Beer, Wine, or Shot) just click the correspoding Icon and view your estimated BAC below. I created it while a Junior at College. BAC Wizard was built using the Ionic Framework with Material Design in mind."
const BACtags = ["JavaScript", "Ionic"]
const BACGooglePlayLink =
  "https://play.google.com/store/apps/details?id=io.Jeff.BAC"

const CodeADiffDescription =
  "Allow programmers that are still learning to sharpen their skills while creating worthwhile projects / websites for small non-profits. This is a full stack application created using React, Redux, and Firebase."
const CodeADiffTags = ["React", "Redux", "Firebase"]

const FunnyWeatherDescription =
  "Co-Create a classic weather app but with a rude twist. This is a full stack iOS and Android application with a NodeJS backend."
const FunnyWeatherTags = ["NodeJS", "Swift", "Kotlin"]
const FunnyWeatherAppStoreLink =
  "https://apps.apple.com/us/app/funny-weather-rude-forecasts/id1499583238"
const FunnyWeatherGooglPlayLink =
  "https://play.google.com/store/apps/details?id=com.epsilonv.funnyweather&hl=en_US"

const DDDescription =
  "Created a React Native application to prompt users to complete daily challenges to get outside of their comfort zone."
const DDTags = ["React Native", "iOS"]
const DDAppStoreLink =
  "https://apps.apple.com/us/app/daily-discomfort/id1535108054"
const DDGooglePlayLink =
  "https://play.google.com/store/apps/details?id=com.jeffedmondson.dailydiscomfort"

const CodeThemeFinderDescription =
  "Created a simple webapp to help developers find their perfect code theme and font for their code editor"
const CodeThemeFinderTags = ["React"]

const tattooScheduleDescription =
  "Tattoo Schedule is a full stack application that allows tattoo artists to manage their appointments and clients."

const tattooScheduleTags = ["React", "NextJS", "Supabase"]

const ProjectsPage = () => {
  return (
    <Layout>
      <Seo title="Projects" pathname="projects" />

      <Container style={{ paddingTop: "50px" }}>
        <Row>
          <Col lg={4}>
            <Project
              title={"TattooSchedule"}
              date={"January 2023"}
              description={tattooScheduleDescription}
              image={FunnyWeatherImage}
              altImage={"Funny Weather Screenshot"}
              tags={tattooScheduleTags}
              link={"https://www.tattooschedule.com/"}
            />
          </Col>

          <Col lg={4}>
            <Project
              title={"Code Theme Finder"}
              date={"March 2022"}
              description={CodeThemeFinderDescription}
              image={CodeThemeFinderImage}
              altImage={"Code Theme Finder Screenshot"}
              tags={CodeThemeFinderTags}
              link={"https://www.codethemefinder.com"}
            />
          </Col>
          <Col lg={4}>
            <Project
              title={"Daily Discomfort"}
              date={"September 2020"}
              description={DDDescription}
              image={Dd}
              altImage={"Daily Discomfort Screenshot"}
              tags={DDTags}
              appStoreLink={DDAppStoreLink}
              googlePlayLink={DDGooglePlayLink}
            />
          </Col>
        </Row>

        <Row style={{ marginTop: "2em" }}>
          <Col lg={4}>
            <Project
              title={"Funny Weather"}
              date={"January 2020"}
              description={FunnyWeatherDescription}
              image={FunnyWeatherImage}
              altImage={"Funny Weather Screenshot"}
              tags={FunnyWeatherTags}
              appStoreLink={FunnyWeatherAppStoreLink}
              googlePlayLink={FunnyWeatherGooglPlayLink}
            />
          </Col>
          <Col lg={4}>
            <Project
              title={"Code A Difference"}
              date={"April 2019"}
              description={CodeADiffDescription}
              image={CodeADiffImage}
              altImage={"Code A Difference Screenshot"}
              tags={CodeADiffTags}
            />
          </Col>
          <Col lg={4}>
            <Project
              title={"BAC Wizard"}
              date={"November 2018"}
              description={BACDescription}
              image={Bac}
              altImage={"BAC Screenshot"}
              tags={BACtags}
              googlePlayLink={BACGooglePlayLink}
            />
          </Col>
        </Row>
      </Container>
    </Layout>
  )
}

export default ProjectsPage
